<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">{{isFrom=='addExercise'?'练习':'课时'}}信息</div>
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="名称   "
              >
                <a-input
                  placeholder="请输入名称"
                  v-decorator="[
                    'chName',
                    {rules: [{ required: true, message: '请输入名称' }]}
                  ]"
                />
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="简介   "
              >
                <a-textarea
                  style="height:80px;resize: none;"
                  placeholder="请输入简介"
                  v-decorator="[
                    'chProfile',
                    {rules: [{ required: true, message: '请输入简介' }]}
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="封面   "
              >
                <div class>
                  <div class="clearfix">
                    <a-upload
                      v-decorator="[
                    'chCover',
                    { valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传封面图片' }]},
                  ]"
                      listType="picture-card"
                      class="face-picture"
                      :showUploadList="false"
                      :action="uploadAction"
                      :headers="headers"
                      :beforeUpload="imgBeforeUpload"
                      @change="courseCoverChange"
                    >
                      <img
                        v-if="chCover.obsObjectUrl"
                        :src="chCover.obsObjectUrl"
                        style="width:100%;"
                      />
                      <div v-else>
                        <a-icon :type="faceloading ? 'loading' : 'plus'" />
                        <div class="ant-upload-text"></div>
                      </div>
                    </a-upload>

                    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                      <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal>
                  </div>
                </div>
                <div class="img-tip">请上传240*200像素或同比例的图片，小于5M!</div>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="顺序   ">
                <a-input placeholder="请输入顺序"  
                    v-decorator="[
                    'chOrder',
                    {rules: [{ required: true, message: '请输入顺序' }]}
                  ]"/>
                <!-- <span class="leave-num-count"></span> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:0px;position:relative;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="词卡内容   "
              >
                <a-table
                  :columns="columns"
                  :bordered="ibordered"
                  :dataSource="picBooks"
                  size="small"
                  :pagination="ipagination"
                >

                  <span slot="customTitle">
                    图片
                    <a-tooltip placement="top">
                      <template slot="title">
                        <span>请上传650*935像素或同比例的图片，小于5M!</span>
                      </template>
                      <a-icon type="question-circle" />
                    </a-tooltip>
                  </span>
                  <!-- 词卡内容删除 -->
                  <span slot="action" slot-scope="text, record,index">
                    
                    <a @click="delPictureBook(index)">删除</a>
                  </span>

                  <!-- 图片上传 -->
                  <span slot="uploadimg" slot-scope="text,record,index">
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label=""
                      style="margin-bottom:0px;"
                    >
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="imgBeforeUpload"
                        @change="value =>picBookImgChange(value,index)"

                        v-decorator="[
                      `picBooks[${index}].picFile`,
                      {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传封面图片' }]},

                    ]"

                      >
                        <img v-if="picBooks[index].picFile.obsObjectUrl" :src="picBooks[index].picFile.obsObjectUrl"  style="width:100%;"/>
                        <div v-else>
                          <a-icon :type="faceloading ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>
                  </span>

                  <!-- 语音上传 -->
                  <span slot="uploadaudit" slot-scope="text, record,index">
                    <a-form-item
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                      label=""
                      style="margin-bottom:0px;"
                    >
                      <a-upload
                        listType="picture-card"
                        class="teach-head-img"
                        :showUploadList="false"
                        :action="uploadAction"
                        :headers="headers"
                        :beforeUpload="audioBeforeUpload"
                        @change="value =>audioChange(value,index)"
                        v-decorator="[
                        `picBooks[${index}].audioFile`,
                        {valuePropName: 'file',getValueFromEvent: normFile,rules: [{ required: true, message: '请上传语音' }]}]"
                      >
                        <span v-if="picBooks[index].audioFile.obsObjectUrl">已上传</span>
                        <div v-else>
                          <a-icon :type="faceloading ? 'loading' : 'plus'" />
                          <div class="ant-upload-text"></div>
                        </div>
                      </a-upload>
                    </a-form-item>

                  </span>


                    
                  <!-- 顺序 -->
                  <span slot="picOrder" slot-scope="text,record,index">
                      <a-icon @click="upOrder(index)" type="arrow-up" v-if="index!=0" :style="{ fontSize: '14px', color: '#FD8F16',cursor: 'pointer'}" />
                      <span @click="downOrder(index)" > 
                      <a-icon  type="arrow-down" v-if="index!=picBooks.length-1" :style="{ fontSize: '14px', color: '#FD8F16',cursor: 'pointer',marginLeft:'10px'}" /></span>
                  </span>



                </a-table>
                <div class="j-teacher-add" style="margin-top:10px;">
                  <a-button
                  style="text-align:center;width:690px;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4;color:#BFC7CD;font-weight:bold;"
                  type="primary"
                  icon="plus"
                  @click="addPicBookItem()">
                  
                  </a-button>
                </div>
                <!-- <a-button @click="addPicBookItem()" type="primary" icon="plus" style="margin-left:8px;">新增词卡</a-button> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:0px;position:relative;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="播放模式   "
              >
                <div class="kaike-radio-list" style="padding-top:13px;">
                  <a-radio-group
                    v-decorator="[
                      'playType',
                      {'initialValue':this.playType}
                    ]"
                    @change="handleChange"
                  >
                    <a-radio :value="`${1}`" style="line-height:1;">自动</a-radio>
                    <a-radio :value="`${0}`" style="line-height:1;">手动</a-radio>
                  </a-radio-group>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:0px;position:relative;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="跟读模式:   "
              >
                <span style="font-size:12px">①2次未匹配到，默认给1星，1个积分；②匹配上根据匹配度打分（1~3），每星1积分</span>
              </a-form-item>
            </a-col>
          </a-row> -->
         
        </div>
      </a-card>
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="picBookCreateOk()"
          >保存</a-button>
        </div>
      </a-card>
    </a-form>
  </div>
</template>

<script>

  import JEditor from '@/components/jeecg/JEditor'
  import Vue from 'vue'
  import { ACCESS_TOKEN ,TENANT_ID } from "@/store/mutation-types"

  import {addCourseHour,queryChDetail,updateCourseHour} from '@/api/api'

  import pick from 'lodash.pick'

  import _ from 'lodash'
  import moment from 'moment'


  // import moment from 'moment'
  // import pick from 'lodash.pick'
  // import { FormTypes } from '@/utils/JEditableTableUtil'
  // import { JEditableTableMixin } from '@/mixins/JEditableTableMixin'
  function getBase64 (img, callback) {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }
  export default {
    name: 'CourseCreate',
    components: { JEditor},
    mixins: [],
    data() {
      return {
        courseId:"",//编辑的时候的课程id
        chName:"", //课程名称
        chProfile:"",//课程简介
        chOrder:"",
        playType:"0",
        isFrom:"",
        chCover:{
          obsObjectUrl:""
        },//课程封面
        ibordered:true,
        ipagination:false,

        chapterList:[],
        columns:[
            { 
                dataIndex: 'picFile',
                slots: { title: 'customTitle' },
                scopedSlots: { customRender: 'uploadimg' },
                align:'center',
                width:90
            },
            {
                title: '语音',
                dataIndex: 'audioFile',
                scopedSlots: { customRender: 'uploadaudit' },
                align:'center',
                width:90
            },
            
            {
                title: '顺序',
                dataIndex: 'order',
                align:'center',
                scopedSlots: { customRender: 'picOrder' },
                width:120
            },
            {
                title: '操作',
                dataIndex: '',
                scopedSlots: { customRender: 'action' },
                align:'center',
                width:120
            },
        ],
        picBooks:[],//词卡列表

        courseDetail:"",//课程详情
        courseTeachers:[
          {
              // id:"",
              idSrc:"",
              teacherDesc:"",
              teacherName:"",
              headFile:""
          }
        ],//课程讲师
        courseType:"0", //所属分类
        courseStartDate:"",//开课日期
        remindFlag:"0",//开课提醒（1-开启，0-关闭）
        buyType:"1",//购买形式（1-付费，0-免费）
        realPrice:"", //价格
        linePrice:"", //划线价

        faceloading:false,
        teachloading:false,

        getTypeValue:"0",//获取方式
        kaikeValue:"0",//
        kaikeStatus:"0",
        form: this.$form.createForm(this),
        loading: false,
        imageUrl: '',
        previewVisible: false,
        previewImage: '',
        fileList: [
        //   {
        //   uid: '-1',
        //   name: 'xxx.png',
        //   status: 'done',
        //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        // }
        ],
        url:{
          fileUpload: window._CONFIG['domianURL']+"/sys/common/upload",
        }
      }
    },
    
    methods: {

      normFile(e) {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.file.response.result;
      },
      // 上移顺序
      upOrder(index){
        let picBooks = JSON.parse(JSON.stringify(this.picBooks));
        let picBooksBk = picBooks[index-1];
        picBooks[index-1] = picBooks[index];
        picBooks[index] = picBooksBk;
        this.picBooks = picBooks;

        this.reOrder();
      },
      // 下移顺序
      downOrder(index){
        let picBooks = JSON.parse(JSON.stringify(this.picBooks));
        let picBooksBk = picBooks[index+1];
        picBooks[index+1] = picBooks[index];
        picBooks[index] = picBooksBk;
        this.picBooks = picBooks;

        this.reOrder();

      },

      reOrder(){
        setTimeout(()=>{
          _.map(this.picBooks,(item,index)=>{
            this.form.setFieldsValue({
                ["picBooks["+(()=>index)()+"].picFile"]:this.picBooks[index].picFile,
                ["picBooks["+(()=>index)()+"].audioFile"]:this.picBooks[index].audioFile,
                ["picBooks["+(()=>index)()+"].word"]:this.picBooks[index].word,
                ["picBooks["+(()=>index)()+"].wordCh"]:this.picBooks[index].wordCh,
                ["picBooks["+(()=>index)()+"].type"]:this.picBooks[index].type,
              })
          })
        },100)
      },
      // 新增词卡
      addPicBookItem(){
        this.picBooks.push({
          picFile:{obsObjectUrl:null},
          audioFile:{obsObjectUrl:null},
          word:"",
          type:"",
          wordCh:""
        })
      },

      // 删除添加的词卡
      delPictureBook(index){
        this.picBooks.splice(index,1);
      },

      // 词卡上传
      picBookImgChange(info,index){

        if (info.file.status === 'uploading') {
          // this.teachloading = true
          return
        }

        this.picBooks[index].picFile = info.file.response.result;

        if (info.file.status === 'done') {
          
          // Get this url from response in real world.
          // getBase64(info.file.originFileObj, (imageUrl) => {
            // this.picBookList[index].idSrc = imageUrl
            // console.log();
            // this.teachloading = false
          // })
        }
      },

      audioChange(info,index){
        if (info.file.status === 'uploading') {
          // this.teachloading = true
          return
        }

        this.picBooks[index].audioFile = info.file.response.result;

        if (info.file.status === 'done') {
          
          // Get this url from response in real world.
          // getBase64(info.file.originFileObj, (imageUrl) => {
            // this.picBookList[index].idSrc = imageUrl
            // console.log();
            // this.teachloading = false
          // })
        }
      },

      handleChange(e){
        // console.log(t,y)
        this.buyType = e.target.value;
      },
      handleCancel () {
        this.previewVisible = false
      },
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      // handleChange ({ fileList }) {
      //   this.fileList = fileList
      // },
      teacherImgChange (info,j,k) {
        if (info.file.status === 'uploading') {
          this.teachloading = true
          return
        }

        // this.courseTeachers[0].id = info.file.response.result.id;
        this.courseTeachers[0].headFile = info.file.response.result;

        if (info.file.status === 'done') {
          // Get this url from response in real world.
          getBase64(info.file.originFileObj, (imageUrl) => {
            this.courseTeachers[0].idSrc = imageUrl
            
            this.teachloading = false
          })
        }
      },

      courseCoverChange(info,i,j){
        if (info.file.status === 'uploading') {
          this.faceloading = true
          return
        }
        if (info.file.status === 'done') {

          this.chCover = info.file.response.result;
          // getBase64(info.file.originFileObj, (imageUrl) => {

          //   this.chCover['obsObjectUrl'] = imageUrl;
          //   this.faceloading = false;

          // })
        }
      },

      // 图片上传前校验
      imgBeforeUpload (file) {
        const isJPG = /\.(gif|jpg|jpeg|png|GIF|JPG|PNG)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传图片!')
        }
       
        const isLt5M = file.size / 1024 / 1024 < 5
        if (!isLt5M) {
          this.$message.error('图片大小要小于5MB!')
        }
        return isJPG && isLt5M
      },

      // 音频上传前校验
      audioBeforeUpload (file) {
        const isJPG = /\.(mp3)$/.test(file.name);

        if(!isJPG){
          this.$message.error('只能上传音频!')
        }
       
        const isLt10M = file.size / 1024 / 1024 < 10
        if (!isLt10M) {
          this.$message.error('图片大小要小于10MB!')
        }
        return isJPG && isLt10M
      },

  

      // 保存
      picBookCreateOk(){
        this.form.validateFields((err, values) => {
          if (!err) {


            let courseId = this.courseId;
            let chapterId = this.chapterId;
            let id = this.id;

            let valuesParam = {};
            valuesParam = {...values,courseId,chapterId,chType:1};
            

            if(this.isFrom==="addExercise"){
              valuesParam['chClass'] = 'e';
            }

            let opFun = "";
            if(_.isEmpty(this.id)){
              opFun = addCourseHour(valuesParam);
            }else{
              valuesParam = {...valuesParam,id}
              opFun = updateCourseHour(valuesParam)  
            }

            opFun.then((res)=>{
              if(res.success==true){
                this.$message.success(res.message,()=>{
                  this.$router.push({ path:'/myCourse/courseDetailEdite?courseId='+this.courseId});
                });
                
              }else{
                this.$message.warning(res.message);
              }

            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })


          }
        })
      },
      
    },
    
    created () {
      const token = Vue.ls.get(ACCESS_TOKEN);
      let tenantid = Vue.ls.get(TENANT_ID)

      this.headers = {"X-Access-Token":token,"tenant_id":tenantid}

      this.courseId = this.$route.query.courseId;
      this.chapterId = this.$route.query.chapterId;
      this.id = this.$route.query.id;
      this.isFrom = this.$route.query.isFrom;

      if(!_.isEmpty(this.id)){
        queryChDetail({id:this.id}).then((res)=>{
          if(res.code==0){
            let resultData = res.result;
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(resultData,'chName','chProfile','chOrder',
              'playType','chCover'))


                this.picBooks  = resultData.picBooks?resultData.picBooks:[];

                setTimeout(()=>{
                  _.map(this.picBooks,(item,index)=>{
                    let  picFileParam= `picBooks[${index}].picFile`;
                    let  audioFileParam= `picBooks[${index}].audioFile`;
                    let  wordParam= `picBooks[${index}].word`;
                    let  wordChParam= `picBooks[${index}].wordCh`;
                    let  typeParam= `picBooks[${index}].type`;
                    this.form.setFieldsValue({
                        ["picBooks["+(()=>index)()+"].picFile"]:this.picBooks[index].picFile,
                        ["picBooks["+(()=>index)()+"].audioFile"]:this.picBooks[index].audioFile,
                        ["picBooks["+(()=>index)()+"].word"]:this.picBooks[index].word,
                        ["picBooks["+(()=>index)()+"].wordCh"]:this.picBooks[index].wordCh,
                        ["picBooks["+(()=>index)()+"].type"]:this.picBooks[index].type,
                      })
                  })
                },500)

            });

            this.chCover = resultData.chCover?resultData.chCover:{obsObjectUrl:""};
      

          }else{
            this.$message.warning(res.message);
          }

        }).finally(() => {
          // that.confirmLoading = false;
          // that.checkedDepartNames = [];
          // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

          // that.close();
        })
      }
      
    },
    computed:{
      uploadAction:function () {
        return this.url.fileUpload;
      }
    },
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
    .ant-upload-list-picture-card {
      .ant-upload-list-item {
        width: 142px !important;
        height: 80px;
      }
    }
    .j-teacher-list {
      .j-teacher-item {
        .j-teacher-item-con {
          width: 587px;
          padding: 20px;
          overflow: hidden;
          border: 1px solid #d0dbe4;
          display: inline-block;
          vertical-align: middle;
          .j-teacher-item-upload {
            width: 90px;
            float: left;
            .ant-upload-select-picture-card {
              width: 80px;
              height: 80px;
            }
          }
          .j-teacher-item-ctx {
            margin-left: 90px;
          }
        }
        .j-teacher-item-cz {
          display: inline-block;
          vertical-align: middle;
          margin-left: 35px;
          color: #0091ff;
          cursor: pointer;
        }
      }
    }
    .kaike-tip {
      color: #fa6400;
      font-size: 12px;
      // line-height: 1;
    }
    .kaike-radio-list {
      line-height: 1;
      .kaike-radio-item {
        line-height: 1;
        margin-bottom: 12px;
        margin-top: 0px;
      }
    }
  }
}
</style>